import { render, staticRenderFns } from "./OrgPick.vue?vue&type=template&id=4dceeab8"
import script from "./OrgPick.vue?vue&type=script&lang=js"
export * from "./OrgPick.vue?vue&type=script&lang=js"
import style0 from "./OrgPick.vue?vue&type=style&index=0&id=4dceeab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports